import React from 'react';
import {
  CustomizedButton,
  CustomizedDialog,
  CustomizedTypography
} from '@components/Customized';
import { useExpireRfqMutation } from '@generated/graphql';
import { Pause } from '@material-ui/icons';

interface Props {
  matches: boolean;
  rfqId: string;
  open: boolean;
  requestClosedStatus: boolean;
  onClose: () => void;
  rfqInfoRefetch: () => void;
}

const CloseRequestDialog = ({
  matches,
  rfqId,
  open,
  requestClosedStatus = false,
  onClose,
  rfqInfoRefetch
}: Props) => {
  const [closeReuqestMutation] = useExpireRfqMutation();

  const onCloseRequest = async () => {
    await closeReuqestMutation({
      variables: {
        rfqId
      }
    }).then(() => {
      rfqInfoRefetch();
      onClose();
    });
  };

  return (
    <CustomizedDialog
      color="error"
      icon={<Pause />}
      title="견적비교 마감"
      open={open}
      onClose={onClose}
      closeButton
    >
      <CustomizedTypography
        variant={matches ? 'body1' : 'h4'}
        color="textPrimary"
        fontWeight="500"
        gutterBottoms={12}
      >
        견적비교를 즉시 마감하시겠습니까?
      </CustomizedTypography>

      <CustomizedTypography
        variant={'body2'}
        color="textSecondary"
        fontWeight="normal"
        gutterBottoms={32}
      >
        견적비교 즉시 마감 시 새로운 파트너로부터 견적을 더 이상 받아보실 수
        없습니다. 기존에 대화를 진행하고 있던 파트너와는 채팅이 가능합니다.
        견적비교를 즉시 마감하시겠습니까?
      </CustomizedTypography>

      <CustomizedButton
        fullWidth
        color="error"
        variant="contained"
        size={matches ? 'medium' : 'large'}
        onClick={onCloseRequest}
        disabled={requestClosedStatus}
      >
        견적비교 마감하기
      </CustomizedButton>
    </CustomizedDialog>
  );
};

export default CloseRequestDialog;
